module.exports = "/virtual-football/img/next-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/next-bck.png
// module id = 138
// module chunks = 6